import request from '../utils/request'

export function register(data) { // 用户注册
  return request({
    url: '/user/register',
    method: 'POST',
    data
  })
}

export function Login(data) { // 密码登录
  return request({
    url: '/user/plogin',
    method: 'POST',
    data
  })
}

export function logout() { // 退出
  return request({
    url: '/user/logout',
    method: 'GET'
  })
}

export function password(data) { // 修改密码
  return request({
    url: '/user/password',
    method: 'POST',
    data
  })
}

export function resetPassword(data) { // 重置密码
  return request({
    url: '/user/reset',
    method: 'POST',
    data
  })
}

export function getInfo() { // 获取用户信息
  return request({
    url: '/user/info',
    method: 'GET'
  })
}

export function saveProfile(data) { // 修改个人信息
  return request({
    url: '/user/profile',
    method: 'POST',
    data
  })
}
